import { render, staticRenderFns } from "./return-data.vue?vue&type=template&id=f168e740&scoped=true"
import script from "./return-data.vue?vue&type=script&lang=js"
export * from "./return-data.vue?vue&type=script&lang=js"
import style0 from "./return-data.vue?vue&type=style&index=0&id=f168e740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f168e740",
  null
  
)

export default component.exports